import request from '@/http/request'

export const getCscDetailReport = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/csc/report/cscDetailReport`, params)
}

export const cscDetailDownload = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/csc/report/cscDetailExport`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
